
export default class UtilRules {//inteded common function for rules module only
    //this will format rules according to QueryBuilderFilterRule of .net
    static FormatRuleToArray(obj,fieldsTypeMap){
        if (obj != null) {
            if (obj.hasOwnProperty("value")) {
                if (Object.prototype.toString.call(obj.value) !== '[object Array]' && obj.value != null) {
                        //what will hapen values:1 will became values:["1"] since it is the accepted format for backend
                    obj.value =  [obj.value];
                }
            }

            //format  the operator equivalent to backend
            if (obj.hasOwnProperty("operator")) {
                if(obj.operator == "contain_value"){
                    obj.operator = "is_not_empty"
                }else if(obj.operator == "not_contain_value"){
                    obj.operator = "is_empty"
                }
            }

            if (obj.hasOwnProperty("field")) {
                fieldsTypeMap.forEach(item => {
                    //here we put type of each field
                    if(item.field === obj.field){
                        obj['type']  = item.type;
                    }
                });
            }

            if (obj.hasOwnProperty("rules") && obj.rules != null) {
                for (var i = 0; i < obj.rules.length; i++) {
                    this.FormatRuleToArray(obj.rules[i],fieldsTypeMap);
                }
            }
        }
    }

    //this is the reverse of FormatRule
    static FormatRuleToString(obj){
        if (obj != null) {
            if (obj.hasOwnProperty("value")) {
                if (Object.prototype.toString.call(obj.value) === '[object Array]' 
                    && ((obj.operator == 'equal' || obj.operator === 'not_equal' )
                        || (obj.operator == 'contains' || obj.operator === 'not_contains' ))) {
                        //what will hapen values:["1"] will became values:1 since it is the accepted format for backend
                    obj.value =  obj.value.toString(); 
                }
            }

            //format back the operator equivalent to frontend
            if (obj.hasOwnProperty("operator")) {
                if(obj.operator == "is_not_empty"){
                    obj.operator = "contain_value"
                }else if(obj.operator == "is_empty"){
                    obj.operator = "not_contain_value"
                }
            }

            if (obj.hasOwnProperty("rules") && obj.rules != null) {
                for (var i = 0; i < obj.rules.length; i++) {
                    this.FormatRuleToString(obj.rules[i]);
                }
            }
        }
    }

    //pass array of object
    static FormatRuleAppliedPropertiesToArray(obj){
        if (obj != null) {
            obj.forEach(ruleApplied => {
                ruleApplied.RuleProperty.forEach(element => {
                    if (element.hasOwnProperty("Value")) {
                        if (Object.prototype.toString.call(element.Value) !== '[object Array]' && element.Value != null) {
                                //what will hapen values:1 will became values:["1"] since it is the accepted format for backend
                                element.Value =  [element.Value];  
                        }
                    }
    
                });
            });

        }
    }


    //pass object
    static FormatObjectRuleAppliedPropertiesToArray(obj){
        if (obj != null) {
            if (Object.prototype.toString.call(obj.Value) !== '[object Array]' && obj.Value != null) {
                //what will hapen values:["1"] will became values:"1" since it is the accepted format for backend
                obj.Value =  [obj.Value]; 
            }
        }
    }

    //pass an array of object
    static FormatRuleAppliedPropertiesToString(obj){
        if (obj != null) {
            obj.forEach(ruleApplied => {
                ruleApplied.RuleProperty.forEach(element => {
                    if (element.hasOwnProperty("Value")) {
                        if (Object.prototype.toString.call(element.Value) === '[object Array]') {
                                //what will hapen values:["1"] will became values:"1" since it is the accepted format for backend
                                element.Value =  element.Value.toString();  
                        }
                    }
                });
            });
        }
    }

    //here you pass object instead of array
    static FormatIndividualRuleAppliedPropertiesToString(obj){
        if (obj != null) {
            obj.RuleProperty.forEach(element => {
                if (element.hasOwnProperty("Value")) {
                    if (Object.prototype.toString.call(element.Value) === '[object Array]' && element.Type != "multiselect" ) {
                            //what will hapen values:["1"] will became values:"1" since it is the accepted format for backend
                            element.Value =  element.Value.toString();  
                    }
                }
            });
        }
    }
    

    //this will remove key of rules json it will only remove empty or null rules so our object CTQueryBuilderComponent will accept
    static RemoveKeys(obj, keys) { 
        for (var prop in obj) {
            if(obj.hasOwnProperty(prop)) {
                switch(typeof(obj[prop])) {
                    case 'object':
                        if(keys.indexOf(prop) > -1) {
                            if(obj[prop].length === 0)
                            {
                            delete obj[prop];
                            }else{
                            this.RemoveKeys(obj[prop], keys);
                            }
                        } else {
                            this.RemoveKeys(obj[prop], keys);
                        }
                        break;
                default:
                        if(keys.indexOf(prop) > -1) {
                            if(obj[prop].length === 0){
                                delete obj[prop];
                            }else{
                                this.RemoveKeys(obj[prop], keys);
                            }
                        }
                        break;
                }
            }
        }
    }

    static is_Numeric(num) {
        return !isNaN(parseFloat(num)) && isFinite(num);
      }
}